export default "__VITE_ASSET__BeOYTGbU__"